import {
    POST_REFRIGERANT_GAS_DATA_SUCCESS,
    POST_REFRIGERANT_GAS_DATA_FAIL,
    GET_REFRIGERANT_GAS_DATA_SUCCESS,
    GET_REFRIGERANT_GAS_DATA_FAIL,
    GET_REFRIGERANT_GAS_DATA_TOTALS_SUCCESS,
    GET_REFRIGERANT_GAS_DATA_TOTALS_FAIL
} from '../../../actions/carbonfootprint-rework/types/01-direct-ghg-emissions-and-removals-types';


const initialState = {
    loading: true,
    refrigerantGasData: [],
    refrigerantGasDataTotals: []
};

// PETROL REDUCERS
export default function
    directGhgEmissionsAndRemovalsForRefrigerantGas(state = initialState, action) {

    const { type, payload } = action;

    switch (type) {
        // STATIONARY PETROL
        case POST_REFRIGERANT_GAS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_REFRIGERANT_GAS_DATA_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_REFRIGERANT_GAS_DATA_SUCCESS:
            return {
                ...state,
                refrigerantGasData: payload,
                loading: false,
            };
        case GET_REFRIGERANT_GAS_DATA_FAIL:
            return {
                ...state,
                refrigerantGasData: payload,
                loading: false
            }
        case GET_REFRIGERANT_GAS_DATA_TOTALS_SUCCESS:
            return {
                ...state,
                refrigerantGasDataTotals: payload,
                loading: false,
            };
        case GET_REFRIGERANT_GAS_DATA_TOTALS_FAIL:
            return {
                ...state,
                refrigerantGasDataTotals: payload,
                loading: false
            }
        default:
            return state;
    }
}


